/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ balance: NonNullable<unknown>, count: NonNullable<unknown> }} Endpoint_Cost_Free_MeteredInputs */

const en_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`The ${i?.balance} starting balance covers at least ${i?.count} requests.`)
};

const zh_hans1_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.balance} 的初始余额至少够 ${i?.count} 次请求。`)
};

const pt_br2_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O saldo inicial de ${i?.balance} cobre pelo menos ${i?.count} requisições.`)
};

const es_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`El saldo inicial de ${i?.balance} alcanza para al menos ${i?.count} solicitudes.`)
};

const fr_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Le solde de départ de ${i?.balance} couvre au moins ${i?.count} requêtes.`)
};

const de_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das Startguthaben von ${i?.balance} deckt mindestens ${i?.count} Anfragen.`)
};

const ru_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Стартового баланса ${i?.balance} хватает минимум на ${i?.count} запросов.`)
};

const it_endpoint_cost_free_metered = /** @type {(inputs: Endpoint_Cost_Free_MeteredInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Il saldo iniziale di ${i?.balance} copre almeno ${i?.count} richieste.`)
};

/**
* | output |
* | --- |
* | "The {balance} starting balance covers at least {count} requests." |
*
* @param {Endpoint_Cost_Free_MeteredInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_cost_free_metered = /** @type {((inputs: Endpoint_Cost_Free_MeteredInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Endpoint_Cost_Free_MeteredInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_endpoint_cost_free_metered(inputs)
	if (locale === "pt-BR") return pt_br2_endpoint_cost_free_metered(inputs)
	if (locale === "es") return es_endpoint_cost_free_metered(inputs)
	if (locale === "fr") return fr_endpoint_cost_free_metered(inputs)
	if (locale === "de") return de_endpoint_cost_free_metered(inputs)
	if (locale === "ru") return ru_endpoint_cost_free_metered(inputs)
	if (locale === "it") return it_endpoint_cost_free_metered(inputs)
	return en_endpoint_cost_free_metered(inputs)
});